// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://rvkkqnakovuvxiyhdacj.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InJ2a2txbmFrb3Z1dnhpeWhkYWNqIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTM2MDM0NjcsImV4cCI6MjA2OTE3OTQ2N30.6zayP7xhymxaP1B05EE1ZNzLFWocYxPKoFnNkp7EKTg";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});